import { generatedAPI } from './endpoints.gen';

export const alertRuleQualityAPIv0alpha1 = generatedAPI;

export const {
  useGetAlertRuleQualityPolicyQuery,
  useCreateAlertRuleQualityPolicyMutation,
  useReplaceAlertRuleQualityPolicyMutation,
} = alertRuleQualityAPIv0alpha1;

export type { AlertRuleQualityPolicy, AlertRuleQualityPolicySpec } from './endpoints.gen';
